import { always, compose } from 'ramda';
import { createAction } from 'redux-actions';

import {
  WATCHLIST_ITEMS_FETCHED,
  WATCHLIST_ITEM_ADDED,
  WATCHLIST_ITEM_REMOVED,
  WATCHLIST_NAVIGATED,
} from 'app/features/watchlist/actionTypes';
import { userId } from 'app/features/user/selectors';
import { seriesIds } from 'app/features/series/selectors';

const watchlistItemsFetched = createAction(WATCHLIST_ITEMS_FETCHED);
const watchlistItemAdded = createAction(WATCHLIST_ITEM_ADDED);
const watchlistItemRemoved = createAction(WATCHLIST_ITEM_REMOVED);
const watchListNavigated = createAction(WATCHLIST_NAVIGATED);

function fetchWatchlistItems() {
  return (dispatch, getState, { api }) =>
    api
      .fetchWatchlistItems({
        accountId: userId(getState()),
        contentIds: seriesIds(getState()),
      })
      .then(compose(dispatch, watchlistItemsFetched))
      .catch(always([]));
}

function addToWatchlist(seriesId) {
  return (dispatch, getState, { api }) =>
    api
      .addToWatchlist({ accountId: userId(getState()), seriesId })
      .then(() => dispatch(watchlistItemAdded(seriesId)));
}

function removeFromWatchlist(seriesId) {
  return (dispatch, getState, { api }) =>
    api
      .removeFromWatchlist({ accountId: userId(getState()), seriesId })
      .then(() => dispatch(watchlistItemRemoved(seriesId)));
}

export {
  fetchWatchlistItems,
  addToWatchlist,
  removeFromWatchlist,
  watchListNavigated,
  watchlistItemAdded,
  watchlistItemRemoved,
};
